export enum UserGroup {
  SPECIAL_DISPLAY_ADMIN = "SPECIAL_DISPLAY_ADMIN",
  THEME_ADMIN = "THEME_ADMIN",
}
